import React, { Component } from 'react';
import _, { map , isEmpty} from 'lodash';
import * as yup from "yup";
import InputText from './InputText';
import moment from "moment-timezone";

import Upload_Photo from "../../../Assets/images/Upload_Photo.svg";
import { message } from "antd";
import CommercialSidebar from "./Sidebar";
import {errorHandle} from "../../Common/errorHandle";

class Step2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      service: [],
      product: [],
      proposal_uuid: null,
      is_overwrite: false,
      additional_comments: '',
      is_submit_btn_active: false,
      serviceFrequency: '',
      cleaningArea: {
        area: [],
        location: ''
      },
      petWaste: {
        bag: [],
        stationInstalling: '',
        isInstalledStation: false,
        count: '',
        location: ''
      },
      trashCan: {
        stationInstalling: '',
        installedStation: false,
        count: '',
        location: ''
      },
      loader: false,
      showSidebar: false,
      commercialData: {},
      errors: [],
      serviceData: [
        {
          id: 'pet_waste_station_service',
          name: 'Pet Waste Station Service',
          value: 'pet_waste_station_service'
        },
        {
          id: 'common_area_cleaning',
          name: 'Common Area Cleaning',
          value: 'common_area_cleaning'
        },
        {
          id: 'trash_can_service',
          name: 'Trash Can Service',
          value: 'trash_can_service'
        },
      ],
      productData: [
        {
          id: 'pet_waste_stations',
          name: 'Pet Waste Stations',
          value: 'pet_waste_stations'
        },
        {
          id: 'pet_waste_station_bags',
          name: 'Pet Waste Station Bags',
          value: 'pet_waste_station_bags'
        }
      ],
      bagsData: [
        {
          id: 'header_bags',
          name: 'Header Bags',
          value: 'header_bags'
        },
        {
          id: 'roll_bags',
          name: 'Roll Bags',
          value: 'roll_bags'
        },
        {
          id: 'dont_know',
          name: 'I Don’t Know',
          value: 'dont_know'
        },
      ],
      stationInstallingData: [
        {
          id: '1-5',
          name: '1-5',
          value: '1-5'
        },
        {
          id: '6-10',
          name: '6-10',
          value: '6-10'
        },
        {
          id: '11-20+',
          name: '11-20+',
          value: '11-20+'
        },
        {
          id: 'dont_know',
          name: 'I Don’t Know',
          value: 'dont_know'
        }
      ],
      serviceFrequencyData: [
        {
          id: 'twice_weekly',
          name: 'Twice Weekly',
          value: 'twice_weekly'
        },
        {
          id: 'weekly',
          name: 'Weekly',
          value: 'weekly'
        },
        {
          id: 'bi_monthly',
          name: 'Every Other Week',
          value: 'bi_monthly'
        },
        {
          id: 'other',
          name: 'Other',
          value: 'other'
        }
      ],
      cleaningAreasData: [
        {
          id: 'all_common_areas',
          name: 'All Common Areas',
          value: 'all_common_areas'
        },
        {
          id: 'specific_locations',
          name: 'Specific Locations',
          value: 'specific_locations'
        }
      ],
      is_quote_added: false,
      is_proposal_added: false,
      is_inner_proposal_added: false,
    }
  }

  UNSAFE_componentWillMount = () => {
    let {proposal_uuid} = this.state;
    proposal_uuid = JSON.parse(sessionStorage.getItem("proposal"));

    if(proposal_uuid === undefined || null)
    {
      this.getCommercialProposal(JSON.parse(sessionStorage.getItem("quote")));
    }
    else
    {
      this.setState({proposal_uuid});
    }

    window.scrollTo(0, 0);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    let {proposal_uuid} = this.state;
    if (Object.keys(nextProps.quote).length > 0 && !this.state.is_quote_added) {
      if (nextProps?.quote?.uuid) {
        let obj = {
          commercial_quote_uuid: nextProps?.quote?.uuid,
          proposal_status: 'enquiry',
          proposal_date: nextProps?.quote?.proposal_due ? moment(nextProps?.quote?.proposal_due).format('YYYY-MM-DD') : null,
        }

        this.props.updateCommercialProposal(proposal_uuid, obj);
        this.setState({is_quote_added: true});
      } else {
        message.error('Quote id not found', 10)
        this.setState({ loader: false });
      }
    } else if (!isEmpty(nextProps?.error)) {
      this.setState({ loader: false });
      errorHandle(nextProps?.error)
    }

    if(Object.keys(nextProps?.proposal)?.length > 0)
    {
      console.log(nextProps?.proposal);
      this.setState({proposal_uuid: nextProps?.proposal?.uuid});
    }

    if (Object.keys(nextProps?.proposal)?.length > 0 && !this.state.is_proposal_added 
      && nextProps?.proposal?.interested_services != null && nextProps?.proposal?.interested_services !== undefined) {
      this.setState(
        {is_proposal_added: true},
        () => this.addInnerProposal(nextProps?.proposal)
      );
    } else if (!isEmpty(nextProps?.error)) {
      errorHandle(nextProps?.error)
      this.setState({ loader: false });
    }
  }

  componentDidMount() {
    window.addEventListener("popstate", () => {
      window.location.assign('/')
    });

    this.props.is_footer && this.onSummaryBack();
  }

  // add inner proposal
  addInnerProposal = (addCommercialProposal) => {
    this.setState({loader: true});

    const {service, product, serviceFrequency} = this.state;
    const arr = [];
    const line_items = [];
    const inner_uuid = JSON.parse(sessionStorage.getItem('inner'));
    const proposal_uuid = JSON.parse(sessionStorage.getItem('proposal'));

    map(service, (item) => {
      let obj_item = {
        item_type: 'service',
        item: item,
        model: '',
        frequency: serviceFrequency,
        description: '',
        discount: '0',
        quantity: '0',
        rate: '0',
        rate_tax: '0',
        s_and_h: '0',
        s_and_h_tax: '0',
        total: '0',
        is_incomplete: true
      }
      line_items.push(obj_item)
    }) // end of inner proposal line items

    map(product, (item) => {
      let obj_item = {
        item_type: 'product',
        item: item,
        model: '',
        frequency: serviceFrequency,
        description: '',
        discount: '0',
        quantity: '0',
        rate: '0',
        rate_tax: '0',
        s_and_h: '0',
        s_and_h_tax: '0',
        total: '0',
        is_incomplete: true
      }
      line_items.push(obj_item)
    }) // end of inner proposal line items
      
    arr.push(
      this.props.updateInnerCommercialProposal( inner_uuid,
        {
          proposal_uuid: proposal_uuid,
          line_items
        })
    );

    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        this.setState({is_inner_proposal_added: true}, () => {
          this.props.resetProposal();
          window.scrollTo(0, 0);
          
          const userDetail = JSON.parse(localStorage.getItem("userKey"))
          sessionStorage.removeItem('commercialStep1');
          // localStorage.clear();
          // sessionStorage.clear();

          if (userDetail) {
            window.location.assign('/account')
          } else {
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(() =>  window.location.reload(this.props.history.replace('/')), 500);
          }
        })
      } else {message.error('Something went wrong.')}
    }).catch(() => {
      message.error('Something went wrong.')
    })
  }

  // single value change
  onChanged = (e) => {
    // e.preventDefault();
    this.setState({ [e.target.name]: e.target.value }, () => this.validate());
  };

  // array value change
  onArrayChanged = (e) => {
    // e.preventDefault();
    const { name, value, checked } = e.target;
    const { service, product } = this.state;
    let data = name === 'service' ? service : product;
    const idx = data.indexOf(value);
    if (checked) {
      idx === -1 && data.push(value);
    } else {
      idx > -1 && data.splice(idx, 1);
    }
    this.setState({ [name]: data }, () => this.validate());
  };

  // object value change
  onObjectTextChanged = (e, name) => {
    const { petWaste, trashCan, cleaningArea } = this.state;
    const isFile = e.target.type === "file"
    let data = name === 'petWaste' ? petWaste : name === 'cleaningArea' ? cleaningArea : trashCan;
    const key = e.target.name;
    const value = isFile ? e.target.files[0] : e.target.value;
    if (isFile && e?.target?.files[0]?.size > (5 * 1048576)) {
      message.error('Image size should be less than 5MB');
    } else {
      if (isFile && !value) {
        console.log('no file');
      } else {
        console.log("isFile:::>", isFile)
        if (isFile) {

          if (value?.type === 'application/pdf') {
            this.getBase64String(value, (result) => {
              Object.assign(data, { [key]: {name: value.name, type: value.type, size: value.size, uri: result }});
              this.setState({ [name]: data }, () => this.validate());
            })
          }
          else {
            message.error('Uploaded file is not a valid');
          }
        }
        else {
          Object.assign(data, { [e.target.name]: value });
          this.setState({ [name]: data }, () => this.validate());
        }
      }
    }
  };

  // pet waste ba value change
  onBagChange = (e) => {
    // e.preventDefault();
    const { value, checked } = e.target;
    const { petWaste } = this.state;
    const { bag } = petWaste;
    // const str = "i don’t know";
    const idx = bag.indexOf(value);
    // const str_idx = bag.indexOf(str);
    if (checked) {
      idx === -1 && bag.push(value);
    } else {
      idx > -1 && bag.splice(idx, 1);
    }
    this.setState({ petWaste }, () => this.validate());
  };

  // object array value change
  onObjectArrayChange = (e, name) => {
    // e.preventDefault();
    const { value, checked } = e.target;
    const { petWaste, cleaningArea } = this.state;
    const { area } = cleaningArea;
    const { bag } = petWaste;
    if (name === 'petWaste') {
      const idx = bag.indexOf(value);
      if (checked) {
        idx === -1 && bag.push(value);
      } else {
        idx > -1 && bag.splice(idx, 1);
      }
      this.setState({ petWaste }, () => this.validate());
    } else { // cleaning area
      const idx = area.indexOf(value);
      if (checked) {
        idx === -1 && area.push(value);
      } else {
        idx > -1 && area.splice(idx, 1);
      }
      this.setState({ cleaningArea }, () => this.validate());
    }
  };

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    // console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // validate required field
  validate = () => {
    // const {
    // service,
    // product,
    // petWaste,
    // trashCan,
    // cleaningArea,
    // serviceFrequency
    // } = this.state;

    // const isPetWasteStation = service?.includes("pet_waste_station_service");
    // const isCommonCleaningArea = service?.includes("common_area_cleaning");
    // const isTrashCan = service?.includes("trash_can_service");

    const schema = yup.object().shape({
      // service: yup.array().required('Service is required'),
      // product: yup.array().required('Product is required'),
      // isPetWasteStation: yup.bool().required(''),
      // isCommonCleaningArea: yup.bool().required(''),
      // isTrashCan: yup.bool().required(''),
      // petWaste: yup.object().shape(
      //   {
      //     isInstalledStation: yup.bool().required(''),
      //     bag: yup.array().when("isInstalledStation", {is: (isInstalledStation) => isPetWasteStation && isInstalledStation, then: yup.array().required('Pet waste station: Bag type is required.')}),
      //     stationInstalling: yup.string().when("isInstalledStation", {is: (isInstalledStation) => isPetWasteStation && !isInstalledStation, then: yup.string().required('Pet waste station: Interested installing count is required.')}),
      //     count: yup.string().when("isInstalledStation", {is: (isInstalledStation) => isPetWasteStation && isInstalledStation, then: yup.string().required('Pet waste station count is required.')}),
      //   }),
      // trashCan: yup.object().shape(
      //   {
      //     installedStation: yup.bool().required(''),
      //     stationInstalling: yup.string().when("installedStation", {is: (installedStation) => isTrashCan && !installedStation, then: yup.string().required('Trash can: Interested installing count is required.')}),
      //     count: yup.string().when("installedStation", {is: (installedStation) => isTrashCan && installedStation, then: yup.string().required('Trash can count is required.')}),
      //   }),
      // cleaningArea: yup.object().shape(
      //   {
      //     area: yup.array().when("isCommonCleaningArea", {is: () => isCommonCleaningArea, then: yup.array().required('Common area cleaning: area is required.')})
      //   }),
      // serviceFrequency: yup.string().when(["isPetWasteStation", "isTrashCan"], {is: () => {
      //   return ((isPetWasteStation && petWaste?.isInstalledStation) || (isTrashCan && trashCan?.installedStation))
      // }, then: yup.string().required('Service frequency is required.')}),
    });

    const data = {
      // service,
      // // product,
      // isPetWasteStation,
      // isCommonCleaningArea,
      // isTrashCan,
      // petWaste,
      // trashCan,
      // cleaningArea,
      // serviceFrequency
    };

    schema.validate(data, { abortEarly: false }).then(() => {
      // this.setState({is_submit_btn_active: true});
    }).catch(() => {
      // this.setState({is_submit_btn_active: false});
      // const errorMsg = error?.errors?.map(str => str);
      // const host = window?.location?.host;
      // if (host?.substring(host, 9) === 'localhost') console.log(`Errors: ${errorMsg}`)
    })
  };

  // api call based on selection
  onSubmit = () => {
    const {
      service,
      product,
      petWaste,
      trashCan,
      cleaningArea,
      additional_comments,
      serviceFrequency,
      showSidebar
    } = this.state;
    const { is_footer } = this.props;

    const step1Data = JSON.parse(sessionStorage.getItem('commercialStep1'));
    const {
      personal_info,
      address,
      communityRole,
      preferredContact,
      communityType,
      communityHome,
      communityBoundaryMap,
      communityBoundaryMapUri,
      contactUs,
      proposalDate,
      isProposal,
      isMoreInfo,
      multiple_contact,
    } = step1Data;

    let phone_numbers = [], pet_waste_station_map = "", common_area_cleaning_map = "", trash_can_location_map = "", community_boundary_map_uri = "";
    
    // eslint-disable-next-line
    phone_numbers = multiple_contact?.filter((item) => {
      if (item.phone) {
        return { phone: item.phone, type: item.type, primary: item.primary }
      }
    });

    if (petWaste?.location?.uri) {
      const arr = petWaste?.location?.uri?.split(';')
      pet_waste_station_map = arr[0] + `;df:${petWaste?.location?.name?.replace('.pdf', '')};` + arr[1]
    }
    if (cleaningArea?.location?.uri) {
      const arr = cleaningArea?.location?.uri?.split(';')
      common_area_cleaning_map = arr[0] + `;df:${cleaningArea?.location?.name?.replace('.pdf', '')};` + arr[1]
    }
    if (trashCan?.location?.uri) {
      const arr = trashCan?.location?.uri?.split(';')
      trash_can_location_map = arr[0] + `;df:${trashCan?.location?.name?.replace('.pdf', '')};` + arr[1]
    }

    if (communityBoundaryMapUri) {
      const arr = communityBoundaryMapUri?.split(';')
      community_boundary_map_uri = arr[0] + `;df:${communityBoundaryMap?.name?.replace('.pdf', '')};` + arr[1]
    }

    const isEmpty = Object.values(address).every(x => (x === null || x === ""));
    const isEmptyPhoneNumber = (phone_numbers.every(x => (x === null || x === "")) || phone_numbers.length === 0);
    const area = JSON.parse(sessionStorage.getItem('area'))

    this.setState({ loader: true });

    const email = JSON.parse(sessionStorage.getItem("email"));
    const userData = JSON.parse(localStorage.getItem("userKey"));
    const quoteUUId = JSON.parse(sessionStorage.getItem("quote"));

    setTimeout(() => {
      let obj = {
        field_office_uuid: area?.uuid,
        first_name: personal_info?.firstName,
        last_name: personal_info?.lastName,
        management_company: personal_info?.company,
        community_name: personal_info?.communityName || null,
        email_address: email,
        role: communityRole,
        reach_out_via: preferredContact,
        properties_in_community: communityType,
        home_count: communityHome,
        community_boundary_map: community_boundary_map_uri,
        is_looking_for_proposal: isProposal || false,
        proposal_due: proposalDate || null,
        would_like_more_info: isMoreInfo || false,
        address: isEmpty ? null : (address?.street_number && address?.route) ? { ...address, address: `${address?.street_number} ${address?.route}` } : address,
        hear_about_us: contactUs,
        outreach: "website",
        interested_products: product, // step 2 data
        interested_services: service,
        is_pet_waste_stations_installed: petWaste?.isInstalledStation || false,
        existing_pet_waste_stations_count: petWaste?.count || 0,
        pet_waste_station_map: pet_waste_station_map,
        new_pet_waste_stations_interested: petWaste?.stationInstalling,
        bag_type: petWaste?.bag,
        areas_to_clean: cleaningArea?.area,
        common_area_cleaning_map: common_area_cleaning_map,
        is_trash_cans_installed: trashCan?.installedStation || false,
        trash_cans_count: trashCan?.count || 0,
        trash_can_location_map: trash_can_location_map,
        new_trash_cans_interested: trashCan?.stationInstalling,
        current_frequency: serviceFrequency,
        additional_comments: additional_comments || null,
        zip_code: area?.zipcode,
        is_crm: false
      }

      if (userData?.user?.uuid) Object.assign(obj, { user_uuid: userData?.user?.uuid,/* user: userData?.user */});
      if (_.isEmpty(userData)) Object.assign(obj, { phone_numbers: isEmptyPhoneNumber ? [] : phone_numbers, });
      if (!(is_footer && !showSidebar)) {
        setTimeout(() => {
          this.props.onSubmit(quoteUUId, obj);
          this.props.updateCustomerLastCompletedStep({
            step: 3,
            tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
          });
        }, 1000);
      }

      this.setState({ errors: [], commercialData: obj, showSidebar: is_footer });
      sessionStorage.setItem('newUserEmail', personal_info?.email);

      try {
        sessionStorage.setItem('commercialData', JSON.stringify(obj));
      } catch (e) { console.log('Local Storage is full, Please empty data') }
    }, 500);
  };

  onSummaryBack = () => {
    const { commercialData } = this.state;
    let data = commercialData;
    if (_.isEmpty(data)) {
      data = JSON.parse(sessionStorage.getItem('commercialData'));
    }

    const {
      interested_products, // step 2 data
      interested_services,
      is_pet_waste_stations_installed,
      existing_pet_waste_stations_count,
      pet_waste_station_map,
      new_pet_waste_stations_interested,
      bag_type,
      areas_to_clean,
      common_area_cleaning_map,
      is_trash_cans_installed,
      trash_cans_count,
      trash_can_location_map,
      new_trash_cans_interested,
      current_frequency,
      additional_comments
    } = data || {};

    this.setState({
      service: interested_services || [],
      product: interested_products || [],
      petWaste: {
        bag: bag_type || [],
        stationInstalling: new_pet_waste_stations_interested || '',
        isInstalledStation: is_pet_waste_stations_installed || false,
        count: existing_pet_waste_stations_count || '',
        location: pet_waste_station_map || ''
      },
      trashCan: {
        stationInstalling: new_trash_cans_interested || '',
        installedStation: is_trash_cans_installed || false,
        count: trash_cans_count || '',
        location: trash_can_location_map || ''
      },
      cleaningArea: {
        area: areas_to_clean || [],
        location: common_area_cleaning_map || ''
      },
      comment: additional_comments || '',
      serviceFrequency: current_frequency || '',
    }, () => this.validate());
  };

  // render station service options
  renderStationService = (item, index) => {
    const { service } = this.state;
    const isSelected = service.indexOf(item.value) > -1;
    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`StationService${index}`}>
        <span>{item.name}</span>
        <input
          type="checkbox"
          id={item.id}
          name="service"
          className="custom--checkbox"
          value={item.value}
          onChange={(e) => this.onArrayChanged(e)}
        />
      </label>
    )
  };

  // render product service options
  renderProductService = (item, index) => {
    const { product } = this.state;
    const isSelected = product.indexOf(item.value) > -1;
    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`ProductService${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={item.id} name="product" className="custom--checkbox" value={item.value} onChange={(e) => this.onArrayChanged(e)} />
      </label>
    )
  };

  // render bag options
  renderBag = (item, index) => {
    const { petWaste } = this.state;
    const isSelected = petWaste?.bag?.indexOf(item.value) > -1;
    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`Bag${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={item.id} name="bag" className="custom--checkbox" value={item.value} onChange={(e) => this.onObjectArrayChange(e, 'petWaste')} />
      </label>
    )
  };

  // render station installing option
  renderStationInstalling = (name) => (item, index) => {
    const { petWaste, trashCan } = this.state;
    const data = name === "petWaste" ? petWaste : trashCan;
    return (
      <label htmlFor={`${name}${item.id}`} className={data?.stationInstalling === item.value ? "area_box active_area_box" : "area_box"} key={`StationInstalling${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={`${name}${item.id}`} name="stationInstalling" className="custom--checkbox" value={item.value} onChange={(e) => this.onObjectTextChanged(e, name)} />
      </label>
    )
  };

  // render service frequency option
  renderServiceFrequency = (item, index) => {
    const { serviceFrequency } = this.state;
    return (
      <label htmlFor={item.id} className={serviceFrequency === item.value ? "area_box active_area_box" : "area_box"} key={`BagType${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={item.id} name="serviceFrequency" className="custom--checkbox" value={item.value} onChange={(e) => this.onChanged(e)} />
      </label>
    )
  };

  // render pet waste station block
  renderPetWasteStationBlock = () => {
    const { bagsData, petWaste } = this.state;
    return (
      <div>
        <div className="preferred_contact">
          <h2 className="primary">Pet waste stations</h2>
          <p>Tell us more about what service you are looking for.</p>
        </div>
        <div className="safety_info">
          <ul className="safety_list">
            <li>
              <h4 className="primary pr-3">Does the community have pet waste stations installed?</h4>
              <div className="checkbox_wrapper">
                <div className="chk_switch">
                  <div className="can-toggle can-toggle--size-small">
                    <input id="has_doggy_door" type="checkbox" checked={!petWaste?.isInstalledStation} name="isInstalledStation" onChange={(e) => this.setState({ petWaste: { ...petWaste, "isInstalledStation": !e.target.checked } }, () => this.validate())} />
                    <label htmlFor="has_doggy_door">
                      <div className="can-toggle__switch"
                        data-unchecked="Yes"
                        data-checked="No"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        {
          petWaste?.isInstalledStation ?
            <div>
              <section className="billing_section">
                <div className="billing_control mb-3">
                  <div className="single_control antselect">
                    <InputText
                      type="text"
                      className='form--control'
                      placeholder="How many pet waste stations do you have? "
                      name="count"
                      value={petWaste?.count}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onObjectTextChanged(e, 'petWaste')}
                    />
                  </div>
                </div>
                <div className="billing_control mb-3">
                  <div className="single_control icofield">
                    <span className={petWaste?.location?.name ? 'selected' : 'placeholder'}>{petWaste?.location?.name || 'Upload Map <5MB (optional)'}</span>
                    <InputText
                      type="file"
                      accept="application/pdf"
                      className='form--control ico-txt'
                      placeholder="Upload Map <5MB (optional)"
                      name="location"
                      onChange={(e) => this.onObjectTextChanged(e, 'petWaste')}
                    />

                    <img src={Upload_Photo} alt={""} />
                  </div>
                </div>
              </section>
              <div className="preferred_contact">
                <h4 className="headlabel">What type of bags do you use? <small>(select all that apply)</small></h4>
                <div className="contact_method_wrapper">
                  {
                    map(bagsData, this.renderBag)
                  }
                </div>
              </div>
            </div> : this.renderStationInstallingBlock()
        }
      </div>
    )
  };

  // render station installing block
  renderStationInstallingBlock = () => {
    const { stationInstallingData } = this.state;
    return (
      <div className="preferred_contact">
        <h4 className="headlabel">How many pet waste stations are you interested in installing/servicing? <small>(select one) </small></h4>
        <div className="contact_method_wrapper">
          {
            map(stationInstallingData, this.renderStationInstalling('petWaste'))
          }
        </div>
      </div>
    )
  };

  // render cleaning areas options
  renderCleaningAreas = (item, index) => {
    const { cleaningArea } = this.state;
    const isSelected = cleaningArea?.area?.indexOf(item.value) > -1;
    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`CleaningAreas${index}`}>
        <span>{item.name}</span>
        <input type="checkbox" id={item.id} name="area" className="custom--checkbox" value={item.value} onChange={(e) => this.onObjectArrayChange(e, 'cleaningArea')} />
      </label>
    )
  };

  // render common area cleaning block
  renderCommonAreaCleaningBlock = () => {
    const { cleaningAreasData, cleaningArea } = this.state;
    return (
      <div>
        <div className="preferred_contact">
          <h2 className="primary">Common area cleaning</h2>
          <p>Tell us more about what service you are looking for.</p>
        </div>
        <div className="preferred_contact">
          <h4 className="headlabel">What areas would you like to have cleaned? <small>(select multiple) </small></h4>
          <div className="contact_method_wrapper">
            {
              map(cleaningAreasData, this.renderCleaningAreas)
            }
          </div>
        </div>
        <section className="billing_section">
          <div className="billing_form">
            <div className="billing_control">
              <div className="single_control icofield">
                <span className={cleaningArea?.location?.name ? 'selected' : 'placeholder'}>{cleaningArea?.location?.name || 'Common Map <5MB (optional)'}</span>
                <InputText
                  type="file"
                  accept="application/pdf"
                  className='form--control ico-txt'
                  placeholder="Common Map <5MB (optional)"
                  name="location"
                  onChange={(e) => this.onObjectTextChanged(e, 'cleaningArea')}
                />
                <img src={Upload_Photo} alt={""} />
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  };

  // render trash can installing block
  renderTrashCanInstallingBlock = () => {
    const { stationInstallingData } = this.state;
    return (
      <div className="preferred_contact">
        <h4 className="headlabel">How many trash cans are you interested in installing/servicing? <small>(select one) </small></h4>
        <div className="contact_method_wrapper">
          {
            map(stationInstallingData, this.renderStationInstalling('trashCan'))
          }
        </div>
      </div>
    )
  };

  // render trash can block
  renderTrashCanBlock = () => {
    const { trashCan } = this.state;
    return (
      <div>
        <div className="preferred_contact">
          <h2 className="primary">Trash can service</h2>
          <p>Tell us more about what service you are looking for.</p>
        </div>
        <div className="safety_info">
          <ul className="safety_list">
            <li>
              <h4 className="primary pr-3">Does the community have trash can stations installed?</h4>
              <div className="checkbox_wrapper">
                <div className="chk_switch">
                  <div className="can-toggle can-toggle--size-small">
                    <input id="is_has_doggy_door" type="checkbox" checked={!trashCan?.installedStation} name="installedStation" onChange={(e) => this.setState({ trashCan: { ...trashCan, 'installedStation': !e.target.checked } }, () => this.validate())} />
                    <label htmlFor="is_has_doggy_door">
                      <div className="can-toggle__switch"
                        data-unchecked="Yes"
                        data-checked="No"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        {
          trashCan?.installedStation ?
            <div>
              <section className="billing_section">
                <div className="form-group d-flex flex-column ">
                  <div className="multi_control antselect">
                    <InputText
                      type="text"
                      className='form--control'
                      placeholder="How many trash cans?"
                      name="count"
                      value={trashCan?.count}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onObjectTextChanged(e, 'trashCan')}
                    />
                  </div>
                  <div className="single_control icofield mt-2">
                    <span className={trashCan?.location?.name ? 'selected' : 'placeholder'}>{trashCan?.location?.name || 'Upload Map <5MB (optional)'}</span>
                    <InputText
                      type="file"
                      accept="application/pdf"
                      className='form--control ico-txt'
                      placeholder="Upload Map <5MB (optional)"
                      name="location"
                      onChange={(e) => this.onObjectTextChanged(e, 'trashCan')}
                    />
                    <img src={Upload_Photo} alt={""} />
                  </div>
                </div>
              </section>
            </div> : this.renderTrashCanInstallingBlock()
        }
      </div>
    )
  };

  render() {
    const {
      service,
      serviceData,
      productData,
      loader,
      serviceFrequencyData,
      petWaste,
      trashCan,
      errors,
      showSidebar,
      commercialData,
      additional_comments
    } = this.state;
    const { history, is_footer } = this.props;
    // const commercialData = JSON.parse(sessionStorage.getItem('commercialData'));

    const isPetWasteStation = service?.includes("pet_waste_station_service");
    const isCommonCleaningArea = service?.includes("common_area_cleaning");
    const isTrashCan = service?.includes("trash_can_service");

    return (
      <div className="commercial_form">
        <label className="back_arrow cursor_pointer" onClick={() => showSidebar ? this.setState({ showSidebar: false }, () => this.onSummaryBack()) : this.props.next(0)}><i className="las la-arrow-left"></i>Back </label>
        {
          showSidebar ?
            <div className="col-md-5 col-lg-4 sidebar_mobile_p_0">
              <CommercialSidebar
                history={history}
                commercialData={commercialData}
                is_footer={is_footer}
                onSubmit={this.onSubmit}
              />
            </div> :
            <div>
              <div className="preferred_contact">
                <h2 className="headlabel">What services are you interested in? <small>(select all that apply)</small></h2>
                <div className="contact_method_wrapper sm-w-100">
                  {
                    map(serviceData, this.renderStationService)
                  }
                </div>
              </div>
              <div className="preferred_contact">
                <h2 className="headlabel">What products are you interested in? <small>(select all that apply)</small></h2>
                <div className="contact_method_wrapper sm-w-100">
                  {
                    map(productData, this.renderProductService)
                  }
                </div>
                <hr />
              </div>
              {
                isPetWasteStation && this.renderPetWasteStationBlock()
              }
              {
                isCommonCleaningArea && this.renderCommonAreaCleaningBlock()
              }
              {
                isTrashCan && this.renderTrashCanBlock()
              }
              {
                ((isPetWasteStation && petWaste?.isInstalledStation) || (isTrashCan && trashCan?.installedStation)) &&
                <div className="preferred_contact">
                  <h4 className="headlabel">What is you current frequency of service? <small>(select one)</small></h4>
                  <div className="contact_method_wrapper">
                    {
                      map(serviceFrequencyData, this.renderServiceFrequency)
                    }
                  </div>
                  <hr />
                </div>
              }

              <div className="form-group">
                <h4 className="headlabel">Are there any other additional comments or concerns you would like to share with us?<small>(Optional)</small></h4>
                <textarea className="form--control" placeholder="Let us know!" value={additional_comments} name='additional_comments' onChange={(e) => this.onChanged(e)}></textarea>
              </div>
              <div className="btn-grp float-right col-md-6 p-0">
                <button
                  type="button"
                  className="btn btn--secondary lg-btn w-100"
                  // disabled={!is_submit_btn_active}
                  onClick={() => this.onSubmit()}
                >{is_footer ? 'Continue' : 'Submit Request'}</button>
              </div>
              <div className="error_msg">
                {errors?.map((error, index) => <div key={`${error}${index}`}>{error}</div>)}
              </div>
            </div>
        }
        {loader && <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>}
      </div>
    );
  }
}

export default Step2;